document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.querySelector('cart-drawer');

  document.querySelectorAll('[data-pb-add-bundle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantIds = (btn.getAttribute('data-variant-ids') || '')
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(Boolean)
        .map(Number)
        .filter(function (id) { return Number.isFinite(id) && id > 0; });

      if (!variantIds.length) {
        alert('This bundle is missing a product — please contact us.');
        return;
      }

      var discountCode = btn.getAttribute('data-discount-code');

      btn.setAttribute('disabled', 'disabled');
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';

      var items = variantIds.map(function (variantId) {
        return { id: variantId, quantity: 1 };
      });

      var sections = cartDrawer ? cartDrawer.dataset.section + ',cart-icon-bubble' : 'cart-icon-bubble';

      var addToCart = fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections_url: window.location.pathname,
          sections: sections
        })
      }).then(function (response) {
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('json') === -1) {
          throw new Error('Could not add this bundle to your cart (unexpected server response, status ' + response.status + ').');
        }
        return response.json().then(function (data) {
          if (!response.ok) {
            var message = data && (data.description || data.message) ? (data.description || data.message) : 'Could not add this bundle to your cart.';
            throw new Error(message);
          }
          return data;
        });
      });

      addToCart
        .then(function (data) {
          if (discountCode) {
            // Applies the discount code to the cart session without navigating away.
            return fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' })
              .catch(function () {})
              .then(function () {
                return data;
              });
          }
          return data;
        })
        .then(function (data) {
          if (cartDrawer) {
            cartDrawer.renderContents(data, true);
          } else {
            window.location.href = theme.routes.cart;
          }
        })
        .catch(function (error) {
          console.log(error); // eslint-disable-line
          alert(error.message || 'Could not add this bundle to your cart. One or more items may be sold out.');
        })
        .finally(function () {
          btn.removeAttribute('disabled');
          btn.textContent = originalText;
        });
    });
  });

  // Slider arrows
  document.querySelectorAll('.pb-slider-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('[data-pb-track]');
    var prevBtn = wrap.querySelector('.pb-nav-prev');
    var nextBtn = wrap.querySelector('.pb-nav-next');
    if (!track) return;

    function scrollByPage(direction) {
      var amount = track.clientWidth * 0.9 * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (maxScroll <= 0) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }
      if (prevBtn) {
        prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.35' : '1';
        prevBtn.style.pointerEvents = track.scrollLeft <= 0 ? 'none' : 'auto';
      }
      if (nextBtn) {
        nextBtn.style.opacity = track.scrollLeft >= maxScroll ? '0.35' : '1';
        nextBtn.style.pointerEvents = track.scrollLeft >= maxScroll ? 'none' : 'auto';
      }
    }

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});
